import React from 'react';

import * as S from './styles';

const Slide5: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Subtitle>Vestido e véu, acervo Casa Juisi.</S.Subtitle>
    </S.Container>
  );
};

export { Slide5 };
